import Image from 'next/image';

import { ICustomIcon } from '@app-types/custom-icons';

import disneyFull from '@assets/disney/disney.svg';

interface DisneyIconProps extends ICustomIcon<undefined> {
    className?: string;
}

export function DisneyIcon({ height = 16, ...props }: Readonly<DisneyIconProps>) {
    return <Image height={height} blurDataURL={disneyFull} src={disneyFull} alt='Disney' priority {...props} />;
}
